import React, { memo } from "react";
import cn from "classnames";
import styles from "./ButtonsScene.module.scss";
import { useSettings } from "../../../hooks/useSettings";
import SceneButtonIcons from "../../icons/SceneButtonsIcons";
import { useStoreSystem } from "../../../store";
import shallow from "zustand/shallow";
import { TargetZoomType } from "../../../store/types/store";
import { ChangeSideButtons } from "./ChangeSideButtons";
import { getWallLineVertices } from "./utils";
import { getCameraPositionToMiddleLine, getTargetPositionToMiddleLine } from "../../../store/helpers";
import { HorizontalLine20 } from "../../SVGasComponent";

interface ButtonSceneProps {
    proMode: boolean;
}

const ButtonsScene = memo(({ proMode }: ButtonSceneProps) => {
    const { isVisibleSizes, updateSettings } = useSettings();

    const { targetZoom, setWallZoomTarget, setItemZoomTarget } = useStoreSystem(
        (state) => ({
            targetZoom: state.targetZoom,
            setWallZoomTarget: state.setWallZoomTarget,
            setItemZoomTarget: state.setItemZoomTarget,
        }),
        shallow
    );

    const handleVisibleSizes = () => {
        updateSettings({ isVisibleSizes: !isVisibleSizes });
    };

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <button className={cn(styles.button, isVisibleSizes && styles.active)} onClick={handleVisibleSizes}>
                    <SceneButtonIcons name="toggleSize" />
                </button>
                <HorizontalLine20 />
                {proMode && <ChangeSideButtons />}
                <button
                    className={cn(styles.button, targetZoom === "item" && styles.active)}
                    onClick={setItemZoomTarget}
                >
                    <SceneButtonIcons name="zoomIn" />
                </button>
                <HorizontalLine20 />
                <button
                    className={cn(styles.button, targetZoom === "wall" && styles.active)}
                    onClick={setWallZoomTarget}
                >
                    <SceneButtonIcons name="zoomOut" />
                </button>
            </div>
        </div>
    );
});

export default ButtonsScene;
